// src/authpages/group/StudyMethods.js
import React, { useState } from 'react';
import { 
  Award, 
  UserPlus, 
  Clock, 
  ChevronDown, 
  ChevronUp 
} from 'lucide-react';

const StudyMethods = ({ studyMethods }) => {
  const [expandedMethod, setExpandedMethod] = useState(null);

  const toggleMethodExpansion = (index) => {
    setExpandedMethod(expandedMethod === index ? null : index);
  };

  return (
    <div className="bg-blue-50 rounded-lg p-6 mb-6">
      <h2 className="text-2xl font-semibold mb-4 text-blue-800 flex items-center">
        <Award className="mr-3 text-yellow-500" /> Proven Study Methods
      </h2>
      <div className="space-y-6">
        {studyMethods.map((method, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
            {/* Method Header */}
            <div 
              className="p-4 cursor-pointer bg-gradient-to-r from-blue-50 to-white flex justify-between items-center"
              onClick={() => toggleMethodExpansion(index)}
            >
              <div>
                <h3 className="font-bold text-lg text-blue-600">{method.name}</h3>
                <p className="text-gray-600">{method.description}</p>
              </div>
              <div className="flex items-center">
                {expandedMethod === index ? 
                  <ChevronUp className="text-blue-500" /> : 
                  <ChevronDown className="text-blue-500" />
                }
              </div>
            </div>
            
            {/* Method Details */}
            {expandedMethod === index && (
              <div className="p-4 border-t border-gray-100">
                {/* Recommendations Section */}
                <div className="mb-4 flex flex-wrap gap-4">
                  <div className="bg-blue-50 p-3 rounded-lg flex items-center">
                    <UserPlus className="mr-2 text-blue-500" size={18} />
                    <div>
                      <p className="text-xs text-gray-500">Recommended Group Size</p>
                      <p className="font-medium text-gray-800">{method.recommendedPeople}</p>
                    </div>
                  </div>
                  <div className="bg-blue-50 p-3 rounded-lg flex items-center">
                    <Clock className="mr-2 text-blue-500" size={18} />
                    <div>
                      <p className="text-xs text-gray-500">Recommended Session Duration</p>
                      <p className="font-medium text-gray-800">{method.recommendedTime}</p>
                    </div>
                  </div>
                </div>
                
                {/* Benefits Section */}
                <div className="mb-4">
                  <h4 className="font-semibold text-blue-800 mb-2">Benefits</h4>
                  <ul className="list-disc list-inside text-sm text-gray-700 grid grid-cols-2 gap-2">
                    {method.benefits.map((benefit, bidx) => (
                      <li key={bidx}>{benefit}</li>
                    ))}
                  </ul>
                </div>
                
                {/* How To Do Section */}
                <div className="mb-4">
                  <h4 className="font-semibold text-blue-800 mb-2">How To Do It</h4>
                  <ol className="list-decimal list-inside text-sm text-gray-700">
                    {method.howToDo.map((step, sidx) => (
                      <li key={sidx} className="mb-1">{step}</li>
                    ))}
                  </ol>
                </div>
                
                {/* Example Section */}
                <div>
                  <h4 className="font-semibold text-blue-800 mb-2">Example Scenario</h4>
                  <div className="bg-gray-50 p-3 rounded-lg">
                    <p className="font-medium text-gray-700 mb-1">{method.example.context}</p>
                    <p className="text-sm text-gray-600 whitespace-pre-line">
                      {method.example.scenario}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudyMethods;